import { NavLink } from 'react-router-dom';
import { Search, Briefcase, Plus, User } from 'lucide-react';
import { cn } from '@nextdone/ui';
import { hapticTick } from '../lib/haptics';

const NAV = [
  { to: '/', label: 'Browse', Icon: Search, end: true },
  { to: '/deals', label: 'Deals', Icon: Briefcase, end: false },
  { to: '/post', label: 'Post', Icon: Plus, end: false },
  { to: '/profile', label: 'Profile', Icon: User, end: false },
];

/** v2 tab bar: 4 flat columns over a hairline. Active is simply brighter —
 * navigation never gets color. */
export function TabBar() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 z-50 w-full max-w-app bg-app border-t border-hairline pb-[max(6px,env(safe-area-inset-bottom))]">
      <div className="grid grid-cols-4">
        {NAV.map(({ to, label, Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            aria-label={label}
            onClick={hapticTick}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-[3px] min-h-[var(--tap-min)] pt-2 pb-0.5',
                'transition-colors duration-fast ease-linear',
                isActive ? 'text-fg-1' : 'text-fg-3 hover:text-fg-2',
              )
            }
          >
            <Icon size={21} strokeWidth={1.75} />
            <span className="font-mono text-micro font-medium uppercase tracking-[0.08em]">
              {label}
            </span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
